import { render, staticRenderFns } from "./DetailMessageIntegration.vue?vue&type=template&id=09d762e3&"
import script from "./DetailMessageIntegration.vue?vue&type=script&lang=js&"
export * from "./DetailMessageIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports